import { hfbXxxStringTranslator } from "@coworker/locales";

/**
 * Translates a department code to a human-readable name WITHOUT "HFB XX -" prefix
 * Similar to getDepartmentOptionTitle from useLocationsOptions but simplified
 *
 * @param code - Department code like "01", "02", "Bistro", "whole"
 * @param t - Translation function from i18next
 * @returns Translated department name like "Living Room", "Bistro", "Whole Store"
 */
export const getDepartmentNameFromCode = (
  code: string,
  t: (key: string, options?: any) => string
): string => {
  // Handle numeric HFB codes (e.g., "01", "02", "12")
  if (code.match(/^\d{2}$/)) {
    return hfbXxxStringTranslator(code, t);
  }

  // Handle special department codes
  const translationMap: Record<string, string> = {
    AsIs: "otherAreaAsIsString",
    ClickAndCollect: "otherAreaClickAndCollectString",
    Bistro: "otherAreaBistroString",
    Checkout: "otherAreaCheckoutString",
    CustomerServiceArea: "otherAreaCustomerServiceAreaString",
    EntranceInclGreeter: "otherAreaEntranceInclGreeterString",
    FinancingArea: "otherAreaFinancingAreaString",
    FirstRoom: "otherAreaFirstRoomString",
    FullServeHandouts: "otherAreaFullServeHandoutsString",
    HomeServicePointPlanningStudio:
      "otherAreaHomeServicePointPlanningStudioString",
    IKEAForBusiness: "otherAreaIKEAForBusinessString",
    IKEARestaurant: "otherAreaIKEARestaurantString",
    IngkaCenters: "otherAreaIngkaCentersString",
    OpenTheWalletMarkethall: "otherAreaOpenTheWalletMarkethallString",
    OpenTheWalletShowroom: "otherAreaOpenTheWalletShowroomString",
    ParkingZone: "otherAreaParkingZoneString",
    PickUpPointHub: "otherAreaPickUpPointHubString",
    QuestionsFromCoWorkers: "otherAreaQuestionsFromCoWorkersString",
    Restaurant: "otherAreaRestaurantString",
    SelfServe: "otherAreaSelfServeString",
    Smaland: "otherAreaSmalandString",
    SwedishFoodMarket: "otherAreaSwedishFoodMarketString",
    whole: "wholeStoreString",
  };

  const translationKey = translationMap[code];
  if (translationKey) {
    return t(translationKey);
  }

  // Fallback for unknown codes
  return hfbXxxStringTranslator(code, t);
};
